import { authenticatedPost } from '../../../../../../api/request';

export default async function createMotives(idDoctorUser, motiveBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando un nuevo motivo.');
    const url = `/doctor-profile-management/motives/${idDoctorUser}`;
    return await authenticatedPost(url, onFail, motiveBody);
}
